import { NavMarker } from 'react-rhumb';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PDFError({
  onRetry,
  isPDFError
}) {
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    direction: "column",
    className: "m-top-3",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "DOCUMENT_NOT_FOUND"
    }), /*#__PURE__*/_jsx(UIIllustration, {
      name: "errors/general",
      width: 150,
      className: "m-bottom-3"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pdf.error.errorTitle"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pdf.error.errorDescription"
      })
    }), isPDFError && /*#__PURE__*/_jsx(Button, {
      use: "primary",
      onClick: onRetry,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pdf.error.tryAgain"
      })
    })]
  });
}